import React from 'react';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { ACCESS_LEVELS, useRequiresRateShopperAccessLevel } from '../../../../../hooks/use-has-rate-shopper-access-level';
import { useRateShopperContext } from '../../context/rate-shopper-context';
import { Shopper } from '../shopper';
// @ts-expect-error less import
import style from './style.module.less';

/**
 * @typedef {import('../../../../../prop-types/rate-shopper').RateShopper} RateShopper
 */

// defensive check in the UI to prevent the display of any non-template shoppers
// this applies to the case where users have 'Premium' access to the feature
const filterShoppers = (shoppers, hasPremiumAccess) => {
  if (hasPremiumAccess) {
    return shoppers;
  }

  return shoppers.filter((shopper) => shopper.isTemplate);
};

/**
 * @param {object} props
 * @param {RateShopper[]} props.shoppers
 * @returns {JSX.Element}
 */
export const ShopperCollection = ({ shoppers }) => {
  const hasPremiumAccess = useRequiresRateShopperAccessLevel(ACCESS_LEVELS.PREMIUM);
  const visibleShoppers = filterShoppers(shoppers, hasPremiumAccess);
  const { isRequestingRateShoppers } = useRateShopperContext();
  return (
    <div className={style['shopper-collection']}>
      {isRequestingRateShoppers ? (
        <LoadingIndicator className={style['loading-indicator']} />
      ) : (
        visibleShoppers.map((shopper) => <Shopper key={shopper.serviceCollectionGuid} shopper={shopper} />)
      )}
    </div>
  );
};
